module.exports = __webpack_public_path__ + "static/media/star_icn_landing_card_2.6b86c9cb.svg";